
import {map} from 'rxjs/operators';
import { AfterContentChecked, ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DocumentService } from '../services/document.service';
import {Document} from '../models/Document';
import {DocumentType} from '../../models/documentType.model';
import { FileUploadService } from '../../directives/file-drop/file-upload.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { BehaviorSubject, interval, Observable, of, Subject } from 'rxjs';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import { BaseEntity } from '../../base/BaseEntity';
import { DocumentQuery, PageQuery } from '../models/DocumentQuery';
import { IPageInfo } from '../../base/interfaces/IPageInfo';
import { IFileStoreItem } from '../interfaces/IFileStoreItem';
import { UserService } from '../../services/user.service';
import { MatTabChangeEvent } from '@angular/material';
import { DocumentPreviewComponent } from '../document-preview/document-preview.component';
import { ComponentPortal, DomPortalHost, DomPortalOutlet } from '@angular/cdk/portal';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.css']
})
export class DocumentListComponent implements OnInit, AfterContentChecked {

  public documentUrl: string;
  public showPreview = false;
  public previewFiles: IFileStoreItem[]
  public searchQuery: DocumentQuery;
  public documentIcon: string;
  public isLoading: Subject<boolean> = new BehaviorSubject(false);
  public documentTypes: BaseEntity[];
  public documents: Subject<Document[]> = new BehaviorSubject(null);
  private documentList: Document[];
  public pageInfo: IPageInfo;
  private isInitial: boolean = null;
  private portalOutlet: DomPortalOutlet; 
  public activeType: DocumentType;
  constructor(
    private ref: ChangeDetectorRef,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private fileService: FileUploadService,
    private sanitizer: DomSanitizer,
    public userService: UserService,
    private cfr: ComponentFactoryResolver,
    private ar: ApplicationRef,
    private injector: Injector,
    private overlay: Overlay
  ) {
   }

  ngOnInit() {
    this.activeRoute.queryParams.subscribe(params => {
      if (params) {
        this.isInitial = params['reload'] === 'true';
      }
    });
  }
  ngAfterContentChecked() {
    this.ref.detectChanges();
  }
  OnEdit(event: MouseEvent, document: Document) {
    if (event.button === 1) {
      this.onPreviewOverlay(document.files);
    }
    else {
      this.router.navigate(['/document/edit', document.id]);
    }    
  }
  OnDownload(documentFile: IFileStoreItem) {
    this.fileService.Download(documentFile).subscribe((file) => {
      const fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));
      window.open(<string>fileUrl, '_blank');
    });
  }

  // public imageToShow(file: IFileStoreItem): string {
  //   let ret = null;
  //   const d = Object.assign({}, file);
  //   if (!file || !file.contentType) {
  //     return ret;
  //   } else if (file.contentType.startsWith('application/pdf')) {
  //     ret = 'fa-file-pdf-o';
  //   } else if (file.contentType.startsWith('text/')) {
  //     ret = 'fa-file-text';
  //   } else if (file.contentType.startsWith('application/x-zip')) {
  //     ret = 'fa-file-archive-o';
  //   } else if (file.contentType.startsWith('application/')) {
  //     ret = 'fa-file';
  //   } else if (file.contentType.startsWith('image/')) {
  //     ret = 'fa-file-image-o';
  //   } else {
  //     ret = 'fa-file-o';
  //   }
  //   return ret;
  // }
  private ConrimDelete(id: string): Observable<any> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'dialogs.question',
      message: 'dialogMessages.deleteRecord'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    ));
  }
  OnDelete(document: Document) {
    this.ConrimDelete(document.code).subscribe((ret) => {
      if (ret) {  
        this.documentService.Delete(document.id).subscribe(() => {
          setTimeout(() => {
            this.OnSearch(this.searchQuery);
          }, 300);
        });
      }
    });
  }

  onNew(type: DocumentType) {
    if (type) {
      this.router.navigate(['/document/add',type.id]);
    }
  }
  onTypeSelected(type: DocumentType) {
    this.activeType = type;
  }
  loadingChange(changed:boolean) {
    this.isLoading.next(changed);
  }
  OnSearch(query: DocumentQuery) {
    if (query && query.typeId) {
      this.isLoading.next(true);
      this.searchQuery = query;
      this.loadData(true);
    }
  }
  abstrctUserName(doc: Document) {
    const text = doc.lastChangeUserName ?  doc.lastChangeUserName : doc.createdUserName;
    return this.documentService.formatStringOverflow(text, 15);
  }
  loadData(refresh = false) {
    this.documentService.AdvancedQuery(this.searchQuery.typeId, this.searchQuery.filter,
      this.searchQuery.skip, this.searchQuery.size, this.searchQuery.sort, this.searchQuery.sortDesc).pipe(map((ret) => {
      if (ret && ret.payload) {
        ret.payload.forEach((doc) => {
          if (doc && doc.files) {
            doc.hasFiles = (doc.files.length > 0 && doc.files[0].link !== null);
            doc.link = this.documentService.GetDownloadLink(doc.id);
            for (let f = 0; f < doc.files.length; f++) {
              const file = doc.files[f];
              file.image = this.documentService.getThumbnail(file);
              if (f === 0) {
                doc.image = file.image;
              }
            }
          }
        });
      }
      return ret;
    })).subscribe((result) => {
      this.pageInfo = result.pageInfo;
      if (!refresh && this.documentList) {
        this.documentList = [...this.documentList, ...result.payload];
      } else {
        this.documentList = result.payload;
      }

      this.documents.next(this.documentList);
      setTimeout(() => {
        this.isLoading.next(false);
      }, 300);
      if (this.isInitial) {
        this.isInitial = false;
        setTimeout(() => {
          this.OnSearch(this.searchQuery);
        }, 3000);
      }
    });
  }
  onScroll() {
    if (this.searchQuery) {
      this.searchQuery.nextPage();
      this.loadData();
    }
  }
  onClosePreview() {    
    this.showPreview = false;    
  }
  onPreviewOverlay(files: IFileStoreItem[]) {
    const portal = new ComponentPortal(DocumentPreviewComponent);
    const positionStrategy = this.overlay.position()
      .global()
      .right()
      .centerVertically();    

    const overlayRef = this.overlay.create({
      height: '85vh',
      panelClass: 'preview-panel',
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      positionStrategy
    });
    overlayRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        overlayRef.detach();
      }
    })
    overlayRef.backdropClick().subscribe(()=> {
      overlayRef.detach();
    })
    const compRef: ComponentRef<DocumentPreviewComponent> = overlayRef.attach(portal);
    compRef.instance.files = files;    
    compRef.instance.close.subscribe(() => {
      overlayRef.detach();
    })
    compRef.instance.initAttachment(files[0]);
  }
}
